module.exports = __webpack_public_path__ + "img/bet_bg.c58f788b.png";